import { LOADER_HANDLER_TYPES, METHOD_TYPES } from 'utils/constants/index'
import axiosInstance, { microServices } from 'network/apis'

export const getGamesListService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/games/list', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params: data
  })
}

export const getGamesSettingsService = (payload) => {
  return axiosInstance(METHOD_TYPES.get, '/games/settings', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params: payload
  })
}

export const restartGameService = (gameId) => {
  return axiosInstance(METHOD_TYPES.post, '/games/restart-crash-game', {
    gameId
  }, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.submit,
    successMessage: 'Game Restarted Successfully'
  })
}

export const updateGameStatusService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/games/update-game-status', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.submit,
    params: data,
    successMessage: 'Updated Status Successfully'
  })
}

export const updateGamesSettingsService = (data) => {
  return axiosInstance(METHOD_TYPES.post, '/games/update-settings', data, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.submit,
    successMessage: 'Updated Game Settings Successfully'
  })
}
